"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAY_PERIOD_PICKER_TEST_ID = void 0;
exports.PAY_PERIOD_PICKER_TEST_ID = 'pay-period-picker';
